<tax-page-header titleText="user.password.restore.title"></tax-page-header>

<div class="ui-kit-white-card">
  <tax-login-menu></tax-login-menu>

  <div class="ui-kit-white-card__body">
    <form class="card-content" (ngSubmit)="submit()">
      <tax-input
        [class.invalid]="hasError"
        [labelText]="'user.form.login'"
        [id]="'login'"
        name="login"
        [(ngModel)]="login"
        [required]="true"
        [autofocus]="true"
      ></tax-input>

      <div class="white-card-bottom">
        <button class="button_blue" [disabled]="!login" translate>user.password.restore</button>
      </div>

      <button class="back-button" (click)="back()" type="button" translate>group.back</button>
    </form>

    <div class="card-pic">
      <svg-icon key="lock"></svg-icon>
    </div>
  </div>
</div>
